module.exports = __webpack_public_path__ + "img/security-lyric.62985087.png";